/**
 * 判断字符串中最后一个p标签是否闭合，
 * 如果没有就清除最后一个p标签
 * (解决浏览器自动补全标签导致换行的问题)
 * @param str
 */
export const HTMLClosedOrNot = (str) => {
    let newArr = str.split('</p>')
    let result = newArr.map((info, index) => {
        if (index == newArr.length - 1) {
            info = info.replace('<p>', '')
        }
        return info
    })
    return result.join('</p>')
}